const Title = ({text}) => (
  <div className="title">
      <h1 className="title-text">{text}</h1>
  </div>
);

export default Title;
